/**
 * Wait until an image source is renderable before it replaces a currently-painted editor frame.
 *
 * Rejects only when the image fails to load. `decode()` is best-effort pre-painting: browsers reject it
 * for sources whose full decode exceeds internal limits (e.g. large animated GIFs) even though they
 * render fine from `src`, so its failure must not abort the swap.
 */
export const decodeImageUrl = (sourceUrl: string): Promise<void> =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            // `decode()` is best-effort and not guaranteed to exist; when it is missing the load alone is
            // enough, so resolve rather than calling it (which would throw and leave this promise unsettled).
            if (typeof image.decode !== 'function') return resolve();
            image.decode().then(resolve, () => resolve());
        };
        image.onerror = () => reject(new Error('Image failed to load'));
        image.src = sourceUrl;
    });
